import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();
    const {
        color,
        fontSize,
    } = theme.fonts.default;

    // Populate the component parts with theme styles
    return {
        container: {
        },

        icon: {
            color,
            fontSize,
        },

        preview: {
        },
    };
};

export default getTheme;
